import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/lib/stores/store';

type CommonSubscribe = {
  subscribed: boolean;
  init: boolean;
  filter?: object;
  __subscribing: boolean;
};
type CandleStickSubscribe = {
  filter?: {
    chain?: number;
    address?: string;
    interval?: string;
  };
} & CommonSubscribe;

type TokenInfoSubscribe = {
  filter?: {
    address?: string;
    chain?: number;
  };
} & CommonSubscribe;

type TokenInfoSubscribeItem = {
  filter?: {
    [key: string]: {
      address?: string;
      chain?: number;
    };
  };
} & CommonSubscribe;
export type SubscribeKeyType = keyof SubscribeState;
export type SubscribeState = {
  candleStickSubscribe: CandleStickSubscribe;
  simpleTokenInfoSubscribe: TokenInfoSubscribeItem;
  tokenInfoSubscribe: TokenInfoSubscribe;
};

type simpleTokenInfoProps = {
  address?: string;
  chain?: number;
};

const subscribeInitState: SubscribeState = {
  candleStickSubscribe: {
    subscribed: false,
    init: false,
    __subscribing: false,
  },
  simpleTokenInfoSubscribe: {
    subscribed: false,
    init: false,
    __subscribing: false,
  },
  tokenInfoSubscribe: {
    subscribed: false,
    init: false,
    __subscribing: false,
  },
};

type SetSubscribeType =
  | { type: 'candleStickSubscribe'; data: Partial<CandleStickSubscribe> }
  | { type: 'simpleTokenInfoSubscribe'; data: Partial<TokenInfoSubscribe> }
  | { type: 'tokenInfoSubscribe'; data: Partial<TokenInfoSubscribe> };
const subscribeSlice = createSlice({
  name: 'subscribe',
  initialState: subscribeInitState,
  reducers: {
    __unsubscribeAll: (state, {}) => {
      Object.keys(state).forEach((key) => {
        const item = state[key as SubscribeKeyType];

        item.__subscribing = false;
      });
    },
    setSubscribe: (
      state,
      {
        payload: { type, data },
      }: {
        payload: SetSubscribeType;
      },
    ) => {
      if (type == 'simpleTokenInfoSubscribe') {
        if (data?.filter?.address) {
          const address = data?.filter?.address;
          let filter = state[type].filter || {};
          if (address) {
            filter[address] = data?.filter;
          }
          state[type] = {
            ...state[type],
            ...data,
            filter: filter,
            init: true,
          };
        }
      } else {
        state[type] = {
          ...state[type],
          ...data,
          init: true,
        };
      }
    },
  },
});
export const reduxCandleStickSubscribe = (
  state: RootState,
): CandleStickSubscribe => state.subscribe.candleStickSubscribe;

export const reduxAllSubscribe = (state: RootState): SubscribeState =>
  state.subscribe;
export const { setSubscribe, __unsubscribeAll } = subscribeSlice.actions;
export const reduxTokenInfoSubscribe = (state: RootState): TokenInfoSubscribe =>
  state.subscribe.tokenInfoSubscribe;
export default subscribeSlice.reducer;
